import {
  fetchEnterpriseList,
  fetchEnterpriseListadmin,
  addEnterprise,
  fetchEnterpriseInfo,
  bindJointCloudInfo,
  deleteAppVersion,
  fetcheJointCloudIDInfo,
  deliveryApp,
  deliveryrecord,
  downloadrecord,
  deleteDeliveryRecord
} from '@/api/enterpriseAppInfo';
import Vue from 'vue';
const enterprise = {
  state: {
    enterprises: null,
    current: {}
  },
  mutations: {
    SET_ENTERPRISES: (state, list) => {
      state.enterprises = list;
    },
    SET_CURRENT: (state, enID) => {
      for (var i = 0; i < state.enterprises.length; i++) {
        if (state.enterprises[i].enterprise_id == enID) {
          state.current = state.enterprises[i];
          return;
        }
      }
      if (!state.current && state.enterprises.length > 0) {
        state.current = state.enterprises[0];
      }
    },
    UPDATE_ENTERPRISE: (state, en) => {
      var update = false;
      for (var i = 0; i < state.enterprises.length; i++) {
        if (state.enterprises[i].enterprise_id == en.enterprise_id) {
          Vue.set(state.enterprises, i, en)
          update = true;
          break;
        }
      }
      if (!update) {
        state.enterprises.push(en);
      }
    }
  },
  actions: {
    GetEnterpriseList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchEnterpriseList(resdata)
          .then(response => {
            const list = response && response.data;
            commit('SET_ENTERPRISES', list);
            resolve(list);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetEnterpriseListadmin({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchEnterpriseListadmin(resdata)
          .then(response => {
            const list = response && response.data;
            commit('SET_ENTERPRISES', list);
            resolve(list);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    GetEnterpriseInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchEnterpriseInfo(resdata)
          .then(response => {
            const isteam = response && response.data;
            resolve(isteam);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetBindJointCloudInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        bindJointCloudInfo(resdata)
          .then(response => {
            const isteam = response && response.data;
            resolve(isteam);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AddEnterprise({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        addEnterprise(resdata)
          .then(response => {
            const isteam = response && response.data;
            commit('UPDATE_ENTERPRISE', isteam);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    SetCurrentEnterprise({ commit }, enID) {
      commit('SET_CURRENT', enID);
    },

    DeleteAppVersion({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deleteAppVersion(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    GetJointCloudIDInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetcheJointCloudIDInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeliveryApp({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deliveryApp(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeliveryRecord({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deliveryrecord(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DownloadRecord({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        downloadrecord(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteDeliveryRecord({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deleteDeliveryRecord(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
export default enterprise;



// WEBPACK FOOTER //
// ./src/store/modules/enterprise.js